<template>
  <div id="paypal-container">
     <loading :active.sync="busy"/>
    <div id="button-paypal"></div>
  </div>
</template>

<script>
import axios from '../../../config/axios.js'

export default {
  props: {
    product: {
      type: Number,
      required: true,
    },

    success: {
      type: Boolean,
      required: true,
    },

    error: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      busy: false,
    }
  },

  mounted() {
    // Set up the payment:
    // 1. Add a payment callback
    let vm = this
    // 2. Make a request to your server
    let payment = function() {
      return new paypal.Promise(function(resolve, reject) {
        axios.ACCESS.post('/api/paypal/create', {
                product: vm.product
            })
            .then(res => {
                // console.log('billing/createPaypal', res)
                vm.$analytics.logEvent('click', { name: 'paypal_btn_createPaypal' })
                if (res.data.result) {
                  return resolve(res.data.id)
                  vm.prod_id = res.data.id
                } else { throw new Error(res.data) }
            })
            .catch(e => {
              reject()
              this.$emit('update:error', true)
            })
      })
    }

    // Execute the payment:
    // 1. Add an onAuthorize callback
    let onAuthorize = (data) => {
      // console.log('The payment was authorized!');
      // console.log('Payment ID = ',   data.paymentID);
      // console.log('PayerID = ', data.payerID);
      // 2. Make a request to your server
      vm.busy = true
      axios.ACCESS.post('/api/paypal/execute', {
        payment: data.paymentID,
        payer: data.payerID
      })
        .then(res => {
          // console.log('billing/executePayPal', res)
          if (res.data.result) {
            this.$emit('update:success', true)
            this.$store.commit('auth/setAccessToken', res.data.access_token)
            this.$store.commit('auth/storeAccessToken', res.data.access_token)
            this.$store.commit('payment/getPayment', res.data.payment)
            let payment = this.$store.getters['payment/payment']
            this.$analytics.logEvent('purchase', { 
              transactions_id: payment.pay_id,
              value: payment.amount,
              currency: payment.unit,
              product: payment.product,
              name: payment.product_name,
              kind: payment.kind,
              status: payment.status,
            })
          } else {throw new Error(res.data) }
        })
        .catch(e => {
          this.$emit('update:error', true)
        })
        .then(res => {
          vm.busy = false
          vm.$store.commit('welcome/resetEmail')
          vm.$store.commit('welcome/resetProdId')
        })
    }

    paypal.Button.render({
      env: 'production',
      style: {
        label: 'checkout',
        size: 'medium',
        shape: 'rect',
        color: 'blue',
      },

      payment,
      onAuthorize

    }, '#button-paypal')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/shared_components/form/Paypal.vue